var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "webdatalist" },
    [
      _c(
        "f7-list",
        {
          staticClass: "searchbar-found",
          attrs: { "media-list": "", id: "attachment-list" },
        },
        _vm._l(_vm.Attachments, function (group, key) {
          return _c(
            "f7-list-group",
            { key: key },
            [
              _c("f7-list-item", { attrs: { title: key, "group-title": "" } }),
              _vm._v(" "),
              _c("div", { staticClass: "showSmallScreenOnly" }, [
                _c(
                  "ul",
                  _vm._l(group, function (data) {
                    return _c(
                      "li",
                      {
                        key: data.id,
                        staticClass: "swipeout",
                        on: {
                          click: function ($event) {
                            return _vm.view(data.id)
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "item-content swipeout-content" },
                          [
                            _c("div", { staticClass: "item-media" }, [
                              _c("i", {
                                staticClass: "icon list-icon icon-invoice",
                              }),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "item-inner" }, [
                              _c("div", { staticClass: "item-title" }, [
                                _vm._v(_vm._s(data.name)),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "item-after" }, [
                                _vm._v(_vm._s(data.type)),
                              ]),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "swipeout-actions-right" }, [
                          _c(
                            "a",
                            {
                              staticClass: "swipeout-delete",
                              attrs: {
                                href: "#",
                                "data-confirm":
                                  "You won't be able to recover this file from MoneyRoad",
                                "data-confirm-title": "Remove?",
                                "data-close-on-cancel": "true",
                                delete: "",
                              },
                            },
                            [_vm._v("\n                Remove\n              ")]
                          ),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "showLargeScreenOnly" }, [
                _c(
                  "ul",
                  _vm._l(group, function (data) {
                    return _c("li", { key: data.id }, [
                      _c("div", { staticClass: "item-content boxRequest" }, [
                        _c("div", { staticClass: "item-media" }, [
                          _c("i", {
                            staticClass: "icon list-icon icon-invoice",
                          }),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "item-inner",
                            on: {
                              click: function ($event) {
                                return _vm.view(data.id)
                              },
                            },
                          },
                          [
                            _c("div", { staticClass: "item-title" }, [
                              _vm._v(_vm._s(data.name)),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "item-after" }, [
                              _vm._v(_vm._s(data.type)),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "item-media" }, [
                          _c(
                            "button",
                            {
                              staticClass: "button-swipe-out",
                              attrs: {
                                disabled: _vm.$engine.rights.rightIs(
                                  "attachment_supprimer",
                                  false
                                ),
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.removeAttachmentWeb(data.id)
                                },
                              },
                            },
                            [
                              _c("f7-icon", {
                                staticClass: "button-delete",
                                staticStyle: { "font-size": "larger" },
                                style: [
                                  _vm.$engine.rights.rightIs(
                                    "attachment_supprimer",
                                    false
                                  )
                                    ? { color: "grey" }
                                    : { color: "red" },
                                ],
                                attrs: { f7: "close" },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]),
                    ])
                  }),
                  0
                ),
              ]),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }